import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNServiceCode } from 'src/app/models/cnservicecode';
import { ServicesService } from 'src/app/services/services.service';
import { debounceTime } from 'rxjs/operators';
import { CNServiceCodeINAMI } from 'src/app/models/cnservicecodeinami';
import { CNServiceCodeCustom } from 'src/app/models/cnservicecodecustom';

@ManageType('AdminServiceCodeManagementDialogComponent')
@Component({
  selector: 'app-admin-service-code-management-dialog',
  templateUrl: './admin-service-code-management-dialog.component.html',
  styleUrls: ['./admin-service-code-management-dialog.component.scss']
})
export class AdminServiceCodeManagementDialogComponent implements OnInit {

  public codes: CNServiceCode[] = [];
  public displayedColumns = ['code'];
  public codeSearchControl = new UntypedFormControl();
  public code: CNServiceCode;

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<AdminServiceCodeManagementDialogComponent>,
              private services: ServicesService) { }

  ngOnInit(): void {
    this.codeSearchControl.valueChanges.pipe(
      debounceTime(300)).subscribe(value => {
        if (value.length > 2) {
          this.services.searchCode(value).subscribe(codes => {
            this.codes = codes;
          });
        }
      });
  }

  selectCode(code: CNServiceCode) {
    this.services.codeValues(code).subscribe(codeWithValues => {
      this.code = codeWithValues;
    });
  }

  addCode(): void {
    this.code = new CNServiceCodeCustom();
  }

  close() {
    this.dialogRef.close();
  }

}
